<template>
  <div class="wrap">
    <div class="mstrip">
      <span class="mdot" />
      <span class="mtxt">
        <b>Enrolment confirmed</b> · {{ course.course_label }}
        <span v-for="s in course.sessions" :key="s.id">
          · {{ sessionLabel(s) }}: {{ sessionDate(s) }}
        </span>
        <span> · go at your own pace</span>
      </span>
      <a class="mlink" href="#account" @click.prevent="toAccount">
        Manage account →
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrolmentStrip',
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  methods: {
    sessionLabel (s) {
      return s.title.split(' — ')[0]
    },
    sessionDate (s) {
      const d = new Date(s.start_dt.replace(' ', 'T'))
      return d.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    },
    toAccount () {
      const el = document.getElementById('account')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>

<style scoped>
.wrap {
  max-width: var(--maxw);
  margin: 0 auto;
  padding: 0 24px;
}
.mstrip {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 14px 18px;
  margin-top: -22px;
  position: relative;
  z-index: 2;
  box-shadow: 0 14px 30px -22px rgba(13, 27, 42, 0.4);
}
.mdot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ok);
  flex: 0 0 auto;
}
.mtxt {
  font-size: 0.92rem;
}
.mtxt b {
  color: var(--ink);
}
.mlink {
  margin-left: auto;
  font-weight: 600;
  color: var(--teal-dk);
  font-size: 0.9rem;
  text-decoration: none;
}
</style>
